export enum AgentHarnessPendingEventStatus {
    Pending = 'pending',
    Claimed = 'claimed',
    Consumed = 'consumed',
    Discarded = 'discarded',
}

export enum AgentHarnessDrainStrategy {
    SerialIndividual = 'serial_individual',
    LatestState = 'latest_state',
    GroupedSummary = 'grouped_summary',
}

export enum AgentHarnessBucketMode {
    Source = 'source',
    Related = 'related',
}
